import React from "react";

import "../styles.scss";
import "../scripts";

import {
  primaryBlock,
  PrimaryBlockConfig,
  getDefaultProps,
  KameleonElement,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  renderTertiaryBlock,
  BlockType,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box, Paragraph } from "theme-ui";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { EyecatcherType, layoutOptions } from "./types/prop-types";

/** Eyecatcher Primary */
const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.ExtraSmall,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockType: BlockType.Primary,
  blockTheme: BlockTheme.light,
};

export const Eyecatcher = primaryBlock<EyecatcherType>(
  blockConfig,
  ({
    tagline,
    header,
    description,
    image,
    SecondaryBlock,
    TertiaryBlock,
  }: EyecatcherType) => (
    <Box className="primary-eyecatcher-bg-image-v1">
      <Box className="padding-global size">
        <Box className="container-small">
          <Box className="header-100svh">
            <Box className="padding-section-large">
              <Box className="content">
                {tagline && (
                  <Box className="margin-bottom margin-xsmall">
                    <Variants.TagLine>{tagline}</Variants.TagLine>
                  </Box>
                )}
                <Box className="margin-bottom margin-small">
                  <Variants.Heading as="h1">{header}</Variants.Heading>
                </Box>
                {description && <Paragraph>{description}</Paragraph>}
                {renderSecondaryBlock(SecondaryBlock)}
                {renderTertiaryBlock(TertiaryBlock)}
              </Box>
              <Variants.OpacityWrapper>
                <Variants.OpacityLayer className="image-overlay-layer" />
                <Variants.ImageNoRadius
                  className="background-image"
                  src={image.url}
                  alt={image.alt}
                />
              </Variants.OpacityWrapper>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
);

Eyecatcher.defaultProps = getDefaultProps<EyecatcherType>(defaults);

export const Element: KameleonElement = {
  component: Eyecatcher,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
